import {Component, HostListener, inject, ChangeDetectionStrategy} from '@angular/core';
import {ScreenSizeService} from "../../services/screen-size-service/screen-size.service";
import {MatButtonModule} from "@angular/material/button";
import {Router, RouterLink, RouterLinkActive} from "@angular/router";
import {MatMenuModule} from "@angular/material/menu";
import {AppMsalAuthService} from "../../auth/authentication-service/app-msal-auth.service";
import {MatIcon} from "@angular/material/icon";
import {DecimalPipe} from "@angular/common";

@Component({
    selector: 'app-nav',
    imports: [
        RouterLink,
        RouterLinkActive,
        MatButtonModule,
        MatMenuModule,
        MatIcon,
    ],
    templateUrl: './nav.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './nav.component.css'
})
export class NavComponent {
  // Injectables
  screenSizeService = inject(ScreenSizeService);
  authService = inject(AppMsalAuthService);
  router = inject(Router);

  // Signals
  screenSize = this.screenSizeService.screenSize;
}
